import { useEffect, useState } from 'react';

interface UseDotAnimationProps {
  interval?: number;
  isLoading?: boolean;
}

export function useDotAnimation({ interval = 500, isLoading = false }: UseDotAnimationProps) {
  const [count, setCount] = useState(1);

  useEffect(() => {
    if (!isLoading) {
      setCount(1);
      return;
    }
    const id = setInterval(() => {
      setCount((prev) => (prev >= 3 ? 1 : prev + 1));
    }, interval);

    return () => clearInterval(id);
  }, [interval, isLoading]);

  //'.  ', '.. ', '...'
  return '.'.repeat(count).padEnd(3, '\u00A0');
}
